module.exports = __webpack_public_path__ + "static/project-2b-171cacd5cd570c96d263171277eb41eb.png";